import { render, staticRenderFns } from "./AdminManage.vue?vue&type=template&id=44b3d11b&scoped=true"
import script from "./AdminManage.vue?vue&type=script&lang=js"
export * from "./AdminManage.vue?vue&type=script&lang=js"
import style0 from "./AdminManage.vue?vue&type=style&index=0&id=44b3d11b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b3d11b",
  null
  
)

export default component.exports